import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to track page views with Google Analytics 4
 * Automatically tracks route changes in React Router
 */
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if gtag is available
    if (typeof window.gtag === 'function') {
      // Track page view with current path
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title
      });

      console.log('GA4 Page View:', location.pathname);
    } else {
      console.warn('Google Analytics not loaded');
    }
  }, [location]);
};

export default usePageTracking;
